export class EdiaryEntryDetails {
  public entryId: string;
  public questions: EdiaryEntryQuestion[] = [];

  constructor(init?: Partial<EdiaryEntryDetails>) {
    Object.assign(this, init);

    if (init && init.questions)
      this.questions = init.questions.map(q => new EdiaryEntryQuestion(q));
  }
}

export class EdiaryEntryQuestion {
  public orderIndex: number;
  public questionLabel: string;
  public answers: EdiaryEntryQuestionAnswer[] = [];

  constructor(init?: Partial<EdiaryEntryQuestion>) {
    Object.assign(this, init);

    if (init && init.answers)
      this.answers = init.answers.map(a => new EdiaryEntryQuestionAnswer(a));
  }
}

export class EdiaryEntryQuestionAnswer {
  public id: string;
  public value: string;

  constructor(init?: Partial<EdiaryEntryQuestionAnswer>) {
    Object.assign(this, init);
  }
}
